import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { GetNotifyContent, getNotifyContentDetails } from "../../../queries/notify";

export function useNotifyContentDetails({
  enabled = true,
  id,
  onSuccess = () => {},
}: { enabled?: boolean; id?: number | null; onSuccess?: (data: GetNotifyContent) => void } = {}) {
  const networkHeaders = useNetworkHeaders();

  const { data: notifyContent, isLoading: areContentDetailsLoading } = useQuery(
    buildNotifyContentDetailsQueryKey({ id }),
    getNotifyContentDetails(networkHeaders),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      enabled: enabled && !!id,
      onSuccess(data) {
        onSuccess(data);
      },
    },
  );

  return {
    notifyContent,
    areContentDetailsLoading,
  };
}

export function buildNotifyContentDetailsQueryKey(params?: { id?: number | null }) {
  if (!params) {
    return "notifyContentDetails";
  }
  return ["notifyContentDetails", params];
}
